import type {ListMaterialsSearchInput} from "./list-materials.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listMaterialsQueryOptions} from "./list-materials.query-options";

export function useListMaterials(search: ListMaterialsSearchInput) {
  return useQuery({...listMaterialsQueryOptions(search), placeholderData: keepPreviousData});
}
